/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestModelPagedList } from '../../models/export-request-model-paged-list';
import { ExportRequestModelSearch } from '../../models/export-request-model-search';
import { SortDirection } from '../../models/sort-direction';

export interface SearchExportRequestModels$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the export request model's name
 *   * CREATION_DATE : the export request model's creation date
 */
  sortFieldName?: 'NAME' | 'CREATION_DATE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search export request model
     */
    body?: ExportRequestModelSearch
}

export function searchExportRequestModels(http: HttpClient, rootUrl: string, params?: SearchExportRequestModels$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestModelPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchExportRequestModels.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestModelPagedList>;
    })
  );
}

searchExportRequestModels.PATH = '/export-request/model/search';
